(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/widget-area.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/widget-area.js');
"use strict";

const {
  useEffect,
  useState
} = React;
const WidgetArea = _ref => {
  let {
    areaName,
    className,
    fallback = null
  } = _ref;
  const [content, setContent] = useState();
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    svs.core.widget_area.loadArea(areaName, content => {
      setContent(content);
      setIsReady(true);
    });
  }, [areaName]);
  if (content) {
    return React.createElement("div", {
      className: className,
      dangerouslySetInnerHTML: {
        __html: content
      }
    });
  }
  return isReady && fallback;
};
setGlobal('svs.ticket_gifts.components.WidgetArea', WidgetArea);

 })(window);